const CURRENT_ENVIRONMENT = "staging";

export const apiToken = "aa0f-9a36-e0e1-46fa-89c9";

export const baseUrl =
    CURRENT_ENVIRONMENT === "staging"
        ? "https://staging-api.commercey.com/"
        : "https://api.commercey.com/";

export const apiUrl = baseUrl + "admin-users/public/";
export const apiUrl_forCategories = baseUrl + "catalog/public/";
export const apiUrl_forProducts = baseUrl + "catalog/public/";
export const apiUrl_forCustomers = baseUrl + "customers/public";
export const apiUrl_forCart = baseUrl + "cart/public/";

export const apiUrl_forProductImages = baseUrl + "images/public/products/";
export const apiUrl_forUsers = baseUrl + "customers/public/";
export const apiUrl_forOrders = baseUrl + "orders/public/customer";
export const apiUrl_forOrders2 = baseUrl + "orders/public/";
export const apiUrl_forSettings = baseUrl + "settings/public/";
export const apiUrl_forSliders = baseUrl + "settings/public/slider";
